import { Skeleton } from 'ui/skeleton/Skeleton';
import { useTemplateHistoryContext } from '../context/TemplateHistoryContext';
import { TemplateHistoryTable } from './TemplateHistoryTable/TemplateHistoryTable';
import { TemplateHistoryModals } from './modals/TemplateHistoryModals';
import { PageHeader } from 'ui/pageHeader';
import { FlexSpacer } from 'ui/flexSpacer';
import { InputSearch } from 'ui/inputs';
import { useClientPaginatedState } from 'ui/table/hooks/useClientPaginatedState';
import { filterTemplateHistoryRows } from './TemplateHistoryTable/utils';

export const TemplateHistory = () => {
  const { template, isLoading, templateId, templateContentIds, metadata } =
    useTemplateHistoryContext();
  const isTableVisible = !isLoading && metadata && template && templateContentIds;

  const {
    currentPage,
    itemsPerPage,
    numItems,
    rows,
    filter,
    setCurrentPage,
    setFilter,
    setItemsPerPage,
    setSortedBy,
    sortDirection,
    sortedBy,
  } = useClientPaginatedState({
    rows: metadata || [],
    sortedBy: 'email',
    filterFn: filterTemplateHistoryRows,
  });

  return (
    <>
      <PageHeader
        documentTitle={`Template history | ${template?.name}`}
        breadcrumb={{
          content: 'Back to template editor',
          href: `/templates/editor?templateId=${templateId}`,
        }}
      >
        <FlexSpacer justifyContent="space-between" alignItems="stretch">
          {template?.name}
          <InputSearch
            id="template-history-table-filter"
            data-test="template-history-table-filter"
            disabled={!isTableVisible}
            onChange={setFilter}
            value={filter}
            placeholder="Search version"
          />
        </FlexSpacer>
      </PageHeader>
      {isLoading && <Skeleton data-test="template-history-skeleton" height={400} />}
      {isTableVisible && (
        <TemplateHistoryTable
          data-test="template-history-table"
          template={template}
          templateContentIds={templateContentIds}
          rows={rows}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          itemsPerPage={itemsPerPage}
          setItemsPerPage={setItemsPerPage}
          numItems={numItems}
          sortedBy={sortedBy}
          setSortedBy={setSortedBy}
          sortDirection={sortDirection}
        />
      )}
      <TemplateHistoryModals />
    </>
  );
};
